export default __webpack_public_path__ + "static/tech_stack-77ec7dbf2437952949ad49191d6bb771.webp";